import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Reemplaza link_to con data-turbo-stream en contextos donde Turbo Drive está desactivado.
// Hace fetch con Accept: text/vnd.turbo-stream.html y procesa la respuesta como Turbo Stream.
//
// Uso:
//   = link_to 'Toggle', path, data: { controller: 'turbo-fetch', action: 'click->turbo-fetch#perform',
//     turbo_fetch_confirm_value: '¿Seguro?', turbo_fetch_method_value: 'POST' }
export default class extends Controller {
  static values = { confirm: String, method: { type: String, default: 'GET' } }

  perform(event) {
    event.preventDefault()

    if (this.hasConfirmValue && this.confirmValue) {
      if (!window.confirm(this.confirmValue)) return
    }

    const url = this.element.getAttribute('href')
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(url, {
      method: this.methodValue,
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': csrfToken,
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.text()
      })
      .then(html => {
        if (html.trimStart().startsWith('<turbo-stream')) {
          Turbo.renderStreamMessage(html)
        } else {
          const doc = new DOMParser().parseFromString(html, 'text/html')
          const streams = doc.querySelectorAll('turbo-stream')
          if (streams.length > 0) {
            streams.forEach(s => Turbo.renderStreamMessage(s.outerHTML))
          } else {
            window.location.reload()
          }
        }
      })
      .catch(err => console.error('[turbo-fetch]', err))
  }
}
